import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index'
import DefaultLayout from "@/layouts/DefaultLayout"
import AuthenticatedLayout from "@/layouts/AuthenticatedLayout"

Vue.use(VueRouter)

const ifNotAuthenticated = (to, from, next) => {
	if (!store.state.user) {
		next()
	} else {
		next('/')
	}
}

const ifAuthenticated = (to, from, next) => {
	if (store.state.user) {
		next()
	} else {
		next('/sign-in')
	}
}

const routes = [
	{
		path: '/',
		name: 'Home',
		meta: {
			layout: AuthenticatedLayout
		},
		component: () => import('@/views/Home'),
		beforeEnter: ifAuthenticated
	},
	{
		path: '/sign-in',
		name: 'Sign in',
		meta: {
			layout: DefaultLayout
		},
		component: () => import('@/views/User/SignIn'),
		beforeEnter: ifNotAuthenticated
	},
	{
		path: '/sign-up',
		name: 'Sign up',
		meta: {
			layout: DefaultLayout
		},
		component: () => import('@/views/User/SignUp'),
		beforeEnter: ifNotAuthenticated
	},
	{
		path: '/recover-password',
		name: 'Recover password',
		meta: {
			layout: DefaultLayout
		},
		component: () => import('@/views/User/RecoverPassword'),
		beforeEnter: ifNotAuthenticated
	},
	{
		path: '/task/viewTasks',
		name: 'View tasks',
		meta: {
			layout: AuthenticatedLayout
		},
		component: () => import('@/views/Task/ViewTasks'),
		beforeEnter: ifAuthenticated
	},
	{
		path: '/task/createTask',
		name: 'View tasks',
		meta: {
			layout: AuthenticatedLayout
		},
		component: () => import('@/views/Task/CreateTask'),
		beforeEnter: ifAuthenticated
	},
	{
		path: '/city/viewCities',
		name: 'View Cities',
		meta: {
			layout: AuthenticatedLayout
		},
		component: () => import('@/views/City/ViewCities'),
		beforeEnter: ifAuthenticated
	},
	{
		path: '/county/viewCounties',
		name: 'View Counties',
		meta: {
			layout: AuthenticatedLayout
		},
		component: () => import('@/views/County/ViewCounties'),
		beforeEnter: ifAuthenticated
	},
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
	scrollBehavior() {
		return {x: 0, y: 0}
	}
})

export default router
